
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/predictors",
      function () {
        return require("private-next-pages/predictors/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/predictors"])
      });
    }
  